export enum ServiceOrderDepositVatMode {
  ON_DEPOSIT = "ON_DEPOSIT",
  ON_COMPLETION = "ON_COMPLETION",
}
